import { SignatureProvider } from '../context/SignatureProvider'
import { SignaturePage } from '../SignaturePage'

export const SignatureWrapper = () => {
  return (
    <SignatureProvider>
      <SignaturePage/>
    </SignatureProvider>
  )
}
